export const tableHead = [
  'Estímulos',
  'Simbologia',
  'Aplicação no Método',
  'Exemplo',
];
